"use client";
import { useAuth } from "@/hooks";
import { useRouter } from "next/navigation";
import { UserCoinTab, ChangePassword, NotificationTab, UserInfo, CabinetStory, PaymentCandiesTab } from "@/modules/tab-user";
import { definitions } from "@/services/metruyenvl";
import { Tabs, TabsProps } from "antd";
import React from "react";

function UserTab({ info, tab }: { info?: definitions["do.UserDO"]; tab: string }) {
    const { userInfo } = useAuth();
    const router = useRouter();
    const items: TabsProps["items"] = [
        {
            key: "thong-tin",
            label: `Hồ sơ`,
            children: <UserInfo user={info as definitions["do.UserDO"]} />,
        },
        {
            key: "mat-khau",
            label: "Đổi mật khẩu",
            children: <ChangePassword user={info as definitions["do.UserDO"]} />,
        },
        {
            key: "tu-truyen",
            label: "Tủ truyện",
            children: <CabinetStory user={info as definitions["do.UserDO"]} />,
        },
        {
            key: "tai-san",
            label: "Tài sản",
            children: <UserCoinTab user={info as definitions["do.UserDO"]} />,
        },
        {
            key: "mua-keo",
            label: "Mua kẹo",
            children: <PaymentCandiesTab user={info as definitions["do.UserDO"]} />,
        },
        {
            key: "thong-bao",
            label: "Thông báo",
            children: <NotificationTab user={info as definitions["do.UserDO"]} />,
        },
    ];
    const itemsRead: TabsProps["items"] = [
        {
            key: "thong-tin",
            label: `Hồ sơ`,
            children: <UserInfo user={info as definitions["do.UserDO"]} />,
        },

        {
            key: "tu-truyen",
            label: "Tủ truyện",
            children: <CabinetStory user={info as definitions["do.UserDO"]} />,
        },
    ];
    const onChange = (key: string) => {
        // console.log(detail);
        console.log(key);
        router.push(`/ho-so/${key}/${info?.id}`);
    };
    return (
        <div className="p-4 md:p-0 mb-4">
            <Tabs items={info?.id == userInfo.id ? items : itemsRead} defaultActiveKey={tab} tabPosition="top" tabBarStyle={{ color: "black", fontWeight: "600" }} onChange={onChange} size="large" className="mt-10 flex md:hidden" />
            <Tabs items={info?.id == userInfo.id ? items : itemsRead} defaultActiveKey={tab} tabPosition="left" tabBarStyle={{ color: "black", fontWeight: "600" }} onChange={onChange} size="large" className="mt-10 hidden md:flex" />{" "}
        </div>
    );
}

export default UserTab;
